import { render, staticRenderFns } from "./gameNotice.vue?vue&type=template&id=31d669cc&"
import script from "./gameNotice.vue?vue&type=script&lang=js&"
export * from "./gameNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d669cc')) {
      api.createRecord('31d669cc', component.options)
    } else {
      api.reload('31d669cc', component.options)
    }
    module.hot.accept("./gameNotice.vue?vue&type=template&id=31d669cc&", function () {
      api.rerender('31d669cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/gameNotice.vue"
export default component.exports